module.exports = __webpack_public_path__ + "img/daily_necessities_kitchen.f7724abf.jpg";